export enum AuthIntegrationType {
  DIGITAL_INTEGRATION = 'digital-integration',
  TRAUX_TICKETS = 'traux-tickets',
}

